module.exports = __webpack_public_path__ + "static/ultimate-guide-facebook-advertising-cost-in-2020-3acf9f9572fd9c1f45d3a9fba99dae6d.png";